import React, { useCallback, useEffect, useState } from 'react';

import {
  DictionaryInputFormControlViewModel,
  DictionaryTreeFormControlViewModel,
  DictMultilineFormControlViewModel,
  InputValue,
  MultilineFormControlViewModel,
  NumericInputFormControlViewModel,
  TextInputFormControlViewModel,
  TimeInputFormControlViewModel,
} from '../../../../services/form/view-model/FormControlViewModel';
import { TFormControlConnectorProps } from '../FormControlContainer';

import { RequiredHistoryProps } from './HistoryContainer';

export interface IFormTextControlProps
  extends RequiredHistoryProps, TFormControlConnectorProps {
  control:
    | DictionaryInputFormControlViewModel
    | DictMultilineFormControlViewModel
    | MultilineFormControlViewModel
    | NumericInputFormControlViewModel
    | TextInputFormControlViewModel
    | DictionaryTreeFormControlViewModel
    | TimeInputFormControlViewModel;
}

const FormTextControl = <P extends IFormTextControlProps>(
  Component: React.ComponentType<any>
): React.FC<P & IFormTextControlProps> =>
  function WithFormTextControl({
    control,
    onChange,
    onChanged,
    onRef,
    ...props
  }: IFormTextControlProps & P) {
    const [value, setValue] = useState<InputValue>(control.value);

    useEffect(() => {
      setValue(control.value);
    }, [control.value]);

    const onValueChange = useCallback(
      (inputValue: InputValue) => {
        setValue(inputValue);

        if (
          inputValue !== value &&
          (inputValue === null ||
            value === null ||
            String(value).trim() ||
            String(inputValue).trim())
        ) {
          onChange(inputValue);
        }
      },

      [value, onChange]
    );

    const onBlur = useCallback(
      (inputValue: InputValue) => {
        onChange(inputValue);
        onChanged(inputValue);
      },
      [onChange, onChanged]
    );

    return (
      <Component
        onRef={onRef}
        onChange={onValueChange}
        onChanged={onBlur}
        value={value}
        control={control}
        {...props}
      />
    );
  };

export default FormTextControl;
